import React from "react";
import { useStore } from "../../../../../Hooks/useStore";
import { Box, Text } from "grommet";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';
import Utility from "../../../../../util/api/Utility";

export const SliderComponent = ({ slides }) => {
    const { rootStore } = useStore();
    const navigate = useNavigate();

    const textStyle = {
        maxWidth: '100%',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };
    return (
        <Box className="my-slider-container">
            <Box className="new-medical-title">
                <Text>New Medical Events</Text>
            </Box>
            <div style={{ width: 'calc(100% - 72px)' }}>
                <Swiper
                    direction='vertical'
                    slidesPerView={1}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    modules={[Navigation]}
                    navigation={true}
                    scrollbar={{ draggable: true }}
                    className="mySwiper"
                >
                    {slides.map((item, index) => {
                        return (
                            <SwiperSlide>
                                <div style={{width: '100%', display: 'flex',flexDirection: 'row',alignItems: 'center'}}>
                                    <Box className="slide-info">
                                        <Text className="active-slide">{index + 1}</Text>
                                        <Text className="inactive-slide">0f {slides.length}</Text>
                                    </Box>
                                    <Box className="passenger-info after patient-name">
                                        <Text className="title">Patient Name</Text>
                                        <Text className="value">{item.passengerName}</Text>
                                    </Box>
                                    <Box className="passenger-info after flight-no">
                                        <Text className="title">Flight Number</Text>
                                        <Text className="value" style={textStyle}>{item.flightId}</Text>
                                    </Box>
                                    <Box className="passenger-info patient-name">
                                        <Text className="title">MRN</Text>
                                        <Text className="value">{item.id}</Text>
                                    </Box>
                                </div>
                                <Box className="passenger-info">
                                    <Box className="know-more-btn-container">
                                        <Box className="know-more-btn">
                                            <button style={{cursor:"pointer"}} onClick={() => navigate(`/ems/medical-emergencies/emergency/${item.id}`)}>Know more</button>
                                            <Text className="value timestampValue">{Utility.timelog(item.timestamp)}</Text>
                                        </Box>
                                    </Box>
                                </Box>
                            </SwiperSlide>
                        )
                    })
                    }
                </Swiper>
            </div>
        </Box>
    );
}